/**
 * Query params that are blocked from being
 * present in any href or links on the page
 */
export const BLOCKED_QUERY_PARAMS = ['ci', 'cm'];
